import { Component } from '@angular/core';

@Component({
  selector: 'hf-toolbar-button-container',
  templateUrl: './toolbar-button-container.component.html',
  styleUrls: ['./toolbar-button-container.component.scss']
})
export class ToolbarButtonContainerComponent {}
